
<!--// TODO Dependency-->
<mvs-dm-upload
        *ngIf="ticketDto && ticketDto?.typeDto && objectIdentifier"
        [objectIdentifier]="objectIdentifier"
        [documentTypeId]="ticketDto?.typeDto?.dmDocumentTypeDtoId"
        [isDocumentTypeSelectionMode]="false"
        [showDocumentTypeDropdown]="false"
        (onDocumentUploaded)="handleDocumentUploaded($event)"
        layoutVariation="s-version"
></mvs-dm-upload>


<!--// TODO Dependency-->
<mvs-dm-object-documents *ngIf="objectIdentifier"
                         [objectIdentifier]="objectIdentifier"
                         [widgetObjectType]="'dm.DmDocumentAssignment'"
                         [showAssignButton]="assignableTicketObjects?.length > 0"
                         (onObjectSelectEvent)="onObjectSelect($event)"
                         (onAssignToObjectRequest)="openAssignDialog($event)"
>
</mvs-dm-object-documents>

<!-- TM-1000001438: Per-object loading instead of global busy -->
<p-dialog header="Dokument zuweisen"
          [(visible)]="showAssignDialog"
          [modal]="true"
          appendTo="body"
          [style]="{width: '450px'}">
    <div>
        <div class="flex flex-column gap-2" *ngIf="assignableTicketObjects?.length">
            <div *ngFor="let ticketObject of assignableTicketObjects"
                 class="flex align-items-center justify-content-between p-3 border-1 border-round surface-border cursor-pointer hover:surface-ground"
                 [class.opacity-50]="busyTicketObjectId && busyTicketObjectId !== ticketObject.id"
                 [class.pointer-events-none]="busyTicketObjectId"
                 (click)="assignDocumentToObject(ticketObject)">
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-link text-color-secondary"></i>
                    <span>{{getTicketObjectName(ticketObject)}}</span>
                    <span class="text-color-secondary">{{ticketObject.objectTypeDtoName}}</span>
                </div>
                <p-progressSpinner *ngIf="busyTicketObjectId === ticketObject.id"
                                   [style]="{width: '20px', height: '20px'}" strokeWidth="4">
                </p-progressSpinner>
                <i *ngIf="busyTicketObjectId !== ticketObject.id"
                   class="fa-regular fa-chevron-right text-color-secondary"></i>
            </div>
        </div>
    </div>
    <div *ngIf="!assignableTicketObjects?.length" class="p-3 text-color-secondary">
        Keine Ticket-Objekte vorhanden.
    </div>
</p-dialog>

@if (euUserDocuments && euUserDocuments.entries.length) {
        <p-messages severity="error">
                <div class="w-full flex justify-content-between align-items-center">
                    <div class="flex gap-3 align-items-center">
                        <i class="fa-regular fa-triangle-exclamation text-2xl"></i>
                        <div class="flex flex-column gap-1">
                            <span>Warnung: Hochgeladene Dokumente können schädliche Inhalte wie Viren oder Malware enthalten. Stellen Sie sicher, dass Sie der Quelle vertrauen, bevor Sie eine Datei öffnen.</span>
                        </div>
                    </div>
                </div>
        </p-messages>

        <mvs-widget [widgetData]="documentEuWidget"
                    *ngIf="documentEuWidget"
                    (onObjectSelect)="onObjectSelect($event['data'])">
        </mvs-widget>

}
